import React from 'react';
import { AtoZQueryClient, QueryClientProvider } from '@amzn/showtime';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';
import ThemeProvider from './ThemeProvider';
// For more info on React Context Providers, see https://reactjs.org/docs/context.html
export default function ContextProviders({ children }) {
    const queryClient = AtoZQueryClient.getQueryClient();
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(QueryClientProvider, { client: queryClient },
            React.createElement(ThemeProvider, null, children))));
}
//# sourceMappingURL=index.js.map